module.exports = __webpack_public_path__ + "img/qaller.9f4b4a67.png";